const INITIAL_STATE = {
    sections : [
        {
            title: 'Electronics',
            // imageUrl: 'https://i.ibb.co/cvpntL1/hats.png',
                        
            imageUrl: 'images/hats.png', // local file in public/images/
            id: 1,
            linkUrl: 'shop/alocasia',
            sub:[
                {
                    title: 'Computer',
                    // imageUrl: 'https://i.ibb.co/0jqHpnp/sneakers.png',
                    imageUrl: 'images/jackets.png', // local file in public/images/
                    id: 3,
                    linkUrl: 'shop/computer'
                },
                {
                    title: 'Laptop',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 2,
                    linkUrl: 'shop/laptop'
                },
                {
                    title: 'Tablet',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 4,
                    linkUrl: 'shop/tablet'
                },
                {
                    title: 'Echo & Alexa',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 5,
                    linkUrl: 'shop/echo%20&%20alexa'
                },
                {
                    title: 'Kindle',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 6,
                    linkUrl: 'shop/kindle'
                },
                {
                    title: 'Google products',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 7,
                    linkUrl: 'shop/google%20products'
                },
                {
                    title: 'Speakers',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 8,
                    linkUrl: 'shop/speakers'
                },
                {
                    title: 'Wearables & Smartwatches',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 9,
                    linkUrl: 'shop/wearables%20&%20smartwatches'
                },
                {
                    title: 'Hard Drives & Memory',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 10,
                    linkUrl: 'shop/hard%20drives%20memory'
                },
                {
                    title: 'Electronics Others',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 10,
                    linkUrl: 'shop/electronics%20others'
                },
            ]
    
        },
        {
            title: 'Mobile & Accesories',
            // imageUrl: 'https://i.ibb.co/cvpntL1/hats.png',
                        
            imageUrl: 'images/hats.png', // local file in public/images/
            id: 2,
            linkUrl: 'shop/alocasia',
            sub:[
                {
                    title: 'Android',
                    // imageUrl: 'https://i.ibb.co/0jqHpnp/sneakers.png',
                    imageUrl: 'images/jackets.png', // local file in public/images/
                    id: 3,
                    linkUrl: 'shop/android'
                },
                {
                    title: 'iPhone',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 2,
                    linkUrl: 'shop/iphone'
                },
                {
                    title: 'Google Pixel',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 4,
                    linkUrl: 'shop/google%20pixel'
                },
                {
                    title: 'Phone Cases',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 5,
                    linkUrl: 'shop/phone%20cases'
                },
                {
                    title: 'Mobile Accessories',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 6,
                    linkUrl: 'shop/mobile%20accessories'
                },
                {
                    title: 'Other Mobile & Accessories',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 7,
                    linkUrl: 'shop/other%20mobile%20&%20accessories'
                }
            ]
    
        },
        {
            title: 'Home & Decor',
            // imageUrl: 'https://i.ibb.co/cvpntL1/hats.png',
                        
            imageUrl: 'images/hats.png', // local file in public/images/
            id: 3,
            linkUrl: 'shop/alocasia',
            sub:[
                {
                    title: 'Furniture',
                    // imageUrl: 'https://i.ibb.co/0jqHpnp/sneakers.png',
                    imageUrl: 'images/jackets.png', // local file in public/images/
                    id: 3,
                    linkUrl: 'shop/furniture'
                },
                {
                    title: 'Lighting',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 2,
                    linkUrl: 'shop/lighting'
                },
                {
                    title: 'Antiques',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 4,
                    linkUrl: 'shop/antiques'
                },
                {
                    title: 'Bedding',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 5,
                    linkUrl: 'shop/bedding'
                },
                {
                    title: 'Bathware',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 6,
                    linkUrl: 'shop/bathware'
                },
                {
                    title: 'Kitchenware',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 7,
                    linkUrl: 'shop/kitchenware'
                },
                {
                    title: 'Cutlery',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 8,
                    linkUrl: 'shop/cutlery'
                },
                {
                    title: 'Other Home & Decor',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 9,
                    linkUrl: 'shop/other%20home%20&%20decor'
                },
            ]
    
        },
        {
            title: 'Garden & Yard',
            // imageUrl: 'https://i.ibb.co/cvpntL1/hats.png',
                        
            imageUrl: 'images/hats.png', // local file in public/images/
            id: 4,
            linkUrl: 'shop/alocasia',
            sub:[
                {
                    title: 'Lawn Mower',
                    // imageUrl: 'https://i.ibb.co/0jqHpnp/sneakers.png',
                    imageUrl: 'images/jackets.png', // local file in public/images/
                    id: 1,
                    linkUrl: 'shop/lawn%20mower'
                },
                {
                    title: 'Home Improvement',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 2,
                    linkUrl: 'shop/home%20improvement'
                },
                {
                    title: 'Scraper',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 3,
                    linkUrl: 'shop/scraper'
                },
                {
                    title: 'Trimmer',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 4,
                    linkUrl: 'shop/trimmer'
                },
                {
                    title: 'Shovel',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 5,
                    linkUrl: 'shop/shovel'
                },
                {
                    title: 'Hose',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 6,
                    linkUrl: 'shop/hose'
                },
                {
                    title: 'Tools',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 7,
                    linkUrl: 'shop/tools'
                },
                {
                    title: 'Bins',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 8,
                    linkUrl: 'shop/bins'
                },
                {
                    title: 'Cutter',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 9,
                    linkUrl: 'shop/cutter'
                },
                {
                    title: 'Other Garden & Yard',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 10,
                    linkUrl: 'shop/other%20garden%20%26%20yard'
                },
            ]
    
        },
        {
            title: 'Fashion & Clothing',
            // imageUrl: 'https://i.ibb.co/cvpntL1/hats.png',
                        
            imageUrl: 'images/hats.png', // local file in public/images/
            id: 5,
            linkUrl: 'shop/alocasia',
            sub:[
                {
                    title: 'Shoes',
                    // imageUrl: 'https://i.ibb.co/0jqHpnp/sneakers.png',
                    imageUrl: 'images/jackets.png', // local file in public/images/
                    id: 3,
                    linkUrl: 'shop/shoes'
                },
                {
                    title: 'Jeans',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 2,
                    linkUrl: 'shop/jeans'
                },
                {
                    title: 'Tees',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 4,
                    linkUrl: 'shop/tees'
                },
                {
                    title: 'Shirts',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 5,
                    linkUrl: 'shop/shirts'
                },
                {
                    title: 'Jackets',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 6,
                    linkUrl: 'shop/jackets'
                },
                {
                    title: 'Other Fashion & Clothing',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 7,
                    linkUrl: 'shop/other%20fashion%20&%20clothing'
                }
            ]
    
        },
        {
            title: 'Hand crafted',
            // imageUrl: 'https://i.ibb.co/cvpntL1/hats.png',
                        
            imageUrl: 'images/hats.png', // local file in public/images/
            id: 6,
            linkUrl: 'shop/alocasia',
            sub:[
                {
                    title: 'Jewelry',
                    // imageUrl: 'https://i.ibb.co/0jqHpnp/sneakers.png',
                    imageUrl: 'images/jackets.png', // local file in public/images/
                    id: 3,
                    linkUrl: 'shop/jewelry'
                },
                {
                    title: 'Necklaces',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 2,
                    linkUrl: 'shop/necklaces'
                },
                {
                    title: 'Ear rings',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 4,
                    linkUrl: 'shop/ear%20rings'
                },
                {
                    title: 'Post cards',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 5,
                    linkUrl: 'shop/post%20cards'
                },
                {
                    title: 'Posters',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 6,
                    linkUrl: 'shop/posters'
                },
                {
                    title: 'Bracelets',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 7,
                    linkUrl: 'shop/bracelets'
                },
                {
                    title: 'Other Hand crafted',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 8,
                    linkUrl: 'shop/other%20hand%20crafted'
                }
            ]
    
        },
        {
            title: 'Auto Parts & Accessories',
            // imageUrl: 'https://i.ibb.co/cvpntL1/hats.png',
                        
            imageUrl: 'images/hats.png', // local file in public/images/
            id: 7,
            linkUrl: 'shop/alocasia',
            sub:[
                {
                    title: 'Car Audio',
                    // imageUrl: 'https://i.ibb.co/0jqHpnp/sneakers.png',
                    imageUrl: 'images/jackets.png', // local file in public/images/
                    id: 3,
                    linkUrl: 'shop/car%20audio'
                },
                {
                    title: 'Car Electronics',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 2,
                    linkUrl: 'shop/car%20electronics'
                },
                {
                    title: 'Wheels & Tires',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 4,
                    linkUrl: 'shop/wheels%20&%20tires'
                },
                {
                    title: 'Bike Parts',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 5,
                    linkUrl: 'shop/bike%20parts'
                },
                {
                    title: 'Auto Tools',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 6,
                    linkUrl: 'shop/auto%20tools'
                },
                {
                    title: 'Epipremnum',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 7,
                    linkUrl: 'shop/epipremnum'
                },
                {
                    title: 'Other Auto Parts & Accessories',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 8,
                    linkUrl: 'shop/other%20auto%20parts%20&%20accessories'
                }
            ]
    
        },
        {
            title: 'Kids & Babies',
            // imageUrl: 'https://i.ibb.co/cvpntL1/hats.png',
                        
            imageUrl: 'images/hats.png', // local file in public/images/
            id: 8,
            linkUrl: 'shop/alocasia',
            sub:[
                {
                    title: 'Newborn clothing',
                    // imageUrl: 'https://i.ibb.co/0jqHpnp/sneakers.png',
                    imageUrl: 'images/jackets.png', // local file in public/images/
                    id: 3,
                    linkUrl: 'shop/newborn%20clothing'
                },
                {
                    title: 'Strollers',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 2,
                    linkUrl: 'shop/strollers'
                },
                {
                    title: 'Car seats',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 4,
                    linkUrl: 'shop/car%20seats'
                },
                {
                    title: 'Baby carrier',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 5,
                    linkUrl: 'shop/baby%20carrier'
                },
                {
                    title: 'Trainers',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 6,
                    linkUrl: 'shop/trainers'
                },
                {
                    title: 'Toys',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 7,
                    linkUrl: 'shop/toys'
                },
                {
                    title: 'Games',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 8,
                    linkUrl: 'shop/games'
                },
                {
                    title: 'Kids wear',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 9,
                    linkUrl: 'shop/kids%20wear'
                },
                {
                    title: 'Childrens Books',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 10,
                    linkUrl: 'shop/childrens%20books'
                },
                {
                    title: 'School Supplies',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 11,
                    linkUrl: 'shop/school%20supplies'
                },
                {
                    title: 'Baby Care',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 12,
                    linkUrl: 'shop/baby%20care'
                },{
                    title: 'Action Figures',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 13,
                    linkUrl: 'shop/action%20figures'
                },
                {
                    title: 'Other Kids & Babies',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 14,
                    linkUrl: 'shop/other%20kids%20&%20babies'
                },
            ]
    
        },
        {
            title: 'Books & Movies',
            // imageUrl: 'https://i.ibb.co/cvpntL1/hats.png',
                        
            imageUrl: 'images/hats.png', // local file in public/images/
            id: 9,
            linkUrl: 'shop/alocasia',
            sub:[
                {
                    title: 'Books',
                    // imageUrl: 'https://i.ibb.co/0jqHpnp/sneakers.png',
                    imageUrl: 'images/jackets.png', // local file in public/images/
                    id: 3,
                    linkUrl: 'shop/Books'
                },
                {
                    title: 'Comics',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 2,
                    linkUrl: 'shop/comics'
                },
                {
                    title: 'DVD',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 4,
                    linkUrl: 'shop/dvd'
                },
                {
                    title: 'Blu-ray',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 5,
                    linkUrl: 'shop/blu-ray'
                },
                {
                    title: 'Other Books & Movies',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 6,
                    linkUrl: 'shop/other%20books%20&%20movies'
                }
            ]
    
        },
        {
            title: 'Fun & Hobbies',
            // imageUrl: 'https://i.ibb.co/cvpntL1/hats.png',
                        
            imageUrl: 'images/hats.png', // local file in public/images/
            id: 10,
            linkUrl: 'shop/xbox',
            sub:[
                {
                    title: 'Xbox',
                    // imageUrl: 'https://i.ibb.co/0jqHpnp/sneakers.png',
                    imageUrl: 'images/jackets.png', // local file in public/images/
                    id: 3,
                    linkUrl: 'shop/xbox'
                },
                {
                    title: 'Playstation',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 2,
                    linkUrl: 'shop/playstation'
                },
                {
                    title: 'Nintendo',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 4,
                    linkUrl: 'shop/nintendo'
                },
                {
                    title: 'PC Games',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 5,
                    linkUrl: 'shop/pc%20games'
                },
                {
                    title: 'Consoles',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 6,
                    linkUrl: 'shop/consoles'
                },
                {
                    title: 'Controllers',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 7,
                    linkUrl: 'shop/controllers'
                },
                {
                    title: 'Collectibles',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 8,
                    linkUrl: 'shop/collectibles'
                },
                {
                    title: 'Fun Accessories',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 9,
                    linkUrl: 'shop/fun%20accessories'
                },
                {
                    title: 'Travel Accessories',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 10,
                    linkUrl: 'shop/travel%20accessories'
                },
                {
                    title: 'Bicycles',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 11,
                    linkUrl: 'shop/bicycles'
                },
                {
                    title: 'Other Fun & Hobbies',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 12,
                    linkUrl: 'shop/other%20fun%20&%20hobbies'
                },
            ]
    
        },
        {
            title: 'Pets',
            // imageUrl: 'https://i.ibb.co/cvpntL1/hats.png',
                        
            imageUrl: 'images/hats.png', // local file in public/images/
            id: 11,
            linkUrl: 'shop/alocasia',
            sub:[
                {
                    title: 'Pet Supplies',
                    // imageUrl: 'https://i.ibb.co/0jqHpnp/sneakers.png',
                    imageUrl: 'images/jackets.png', // local file in public/images/
                    id: 3,
                    linkUrl: 'shop/pet%20supplies'
                },
                {
                    title: 'Pet Toys',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 2,
                    linkUrl: 'shop/pet%20toys'
                },
                {
                    title: 'Leash',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 4,
                    linkUrl: 'shop/leash'
                },
                {
                    title: 'Other Pets',
                    // imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
                    imageUrl: 'images/sneakers.png', // local file in public/images/
                    id: 5,
                    linkUrl: 'shop/other%20pets'
                }
            ]
    
        },
    ]
};
const directoryReducer = (state = INITIAL_STATE,action) => {
    switch(action.type){
        default:
            return state;
    }
}
export default directoryReducer;